import React from 'react';
import PropTypes from 'prop-types';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

const Expand = ({expand, setExpand}) => {
    const handleClickExpand = (event) => {
        event.preventDefault();
        setExpand(!expand);
    };
    return (expand) ? <ExpandLess onClick={handleClickExpand}/> : <ExpandMore onClick={handleClickExpand}/>;
};

Expand.propTypes = {
    expand: PropTypes.bool.isRequired,
    setExpand: PropTypes.func.isRequired,
};

export default Expand;
